// import './App.css'
// import "./assets/css/styles.min.css";
import { createBrowserRouter, RouterProvider, useRoutes } from "react-router-dom";
import AppContent from "./components/master/AppContent";
import Login from "./components/master/Login";
import PageClient from "./components/modules/clients/PageClient";
import PageLocal from "./components/modules/locals/PageLocal";
import PageEmployee from "./components/modules/employees/PageEmployee";
import PageZone from "./components/modules/zones/PageZone";
import PageAgency from "./components/modules/agencies/PageAgency";
import PageComponent from "./components/modules/components/PageComponent";
import PageAreaEmployee from "./components/modules/areas_employee/PageAreaEmployee";
import PagePermissionComponents from "./components/modules/permission_components/PagePermissionComponents";
import PageCargoEmployee from "./components/modules/cargos_employee/PageCargoEmployee";
import PagePermissionAreaCargoComponents from "./components/modules/permission_area_cargo_components/PagePermissionAreaCargoComponents";
import PageUser from "./components/modules/users/PageUser";
import PageProspection from "./components/modules/prospection/PageProspection";
import PageHome from "./components/modules/home/PageHome";
import PageRegContact from "./components/modules/register_contact/PageRegContact";
import PageEvaluation from "./components/modules/evaluation/PageEvaluation";
import PageCargosAreaEmployee from "./components/modules/cargos_area_employee/PageCargosAreaEmployee";
import PageNivelAprobacion from "./components/modules/niveles_de_aprobacion/PageNivelAprobacion";
import PageFuenteIngreso from "./components/modules/fuentes_de_ingreso/PageFuenteIngreso";

import PagePopulationCenter from "./components/modules/population_centers/PagePopulationCenter";
import PageCategoriaEvaluacion from "./components/modules/categorias_evaluacion/PageCategoriaEvaluacion";
import PageProducto from "./components/modules/productos/PageProducto";
import PageApproval from "./components/modules/approval/PageApproval";
import PageApprovalRate from "./components/modules/approval_rate/PageApprovalRate";
import PageDisburse from "./components/modules/disburse/PageDisburse";
import PageTransactionCredit from "./components/modules/transanctions_credit/PageTransactionCredit";
import PageSerieDocument from "./components/modules/series_document/PageSerieDocument";
import PageCuentaContable from "./components/modules/cuentas_contables/PageCuentaContable";
import PageCaja from "./components/modules/cajas/PageCaja";
import PageMovimientoCaja from "./components/modules/movimientos_caja/PageMovimientoCaja";
import PageMetodoPago from "./components/modules/metodos_pago/PageMetodoPago";
import PageConceptoPagoCaja from "./components/modules/conceptos_pago_caja/PageConceptoPagoCaja";

// import Login from './auth/Login';
// import Error404 from './Pages/Error404';
// import ProtectedRoute from './routes/ProtectedRoute';
// // import { AuthContext } from './auth/AuthProvider';
// import Especialidades from "./Pages/Especialidades";
// import TipoUsuarios from "./Pages/TipoUsuarios";

// import Cita from "./Pages/Cita";
// import Convenios from "./Pages/Convenios";
// // import ConveniosDynamic from "./Pages/ConveniosDinamic";
// import Dashboard from "./auth/Dashboard";
// import Trabajador from "./Pages/Trabajador";
// import Medico from "./Pages/Medico";
// import Programacion from "./Pages/Programacion";
// import ExpiredSession from "./Pages/ExpiredSession";
// import DashboardAdmin from "./components/Inicio/DashboardAdmin";
// import Usuario from "./Pages/Usuario";
// import Periodo from "./Pages/Periodo";
// import Configuracion from "./Pages/Configuracion";
// import Paciente from "./Pages/Paciente";
// import Consultorios from "./Pages/Consultorios";
// import DashboardMedico from "./components/Inicio/DashboardMedico";
// import Notificaciones from "./Pages/Notifications";

// import useExternalScripts from "./helpers/useExternalScripts";
// import Dashboard from "./auth/Dashboard";
function App() {
    const routes = useRoutes([
        { 
            path: '/view',
            element: <AppContent />,
            children: [
                { path: 'clients',  element: <PageClient />, index: true },
                { 
                    path: 'zones',
                    children: [
                        { index: true, element: <PageZone /> },
                        { path: 'new', element: <PageZone /> },
                        { path: ':id', element: <PageZone /> }
                    ]
                },
                { 
                    path: 'agencies',
                    children: [
                        { index: true, element: <PageAgency /> },
                        { path: 'new', element: <PageAgency /> },
                        { path: ':id', element: <PageAgency /> }
                    ]
                },
                {
                    path: 'components',
                    children: [
                        { index: true, element: <PageComponent /> },
                        { path: 'new', element: <PageComponent /> },
                        { path: ':id', element: <PageComponent /> }
                    ]
                },
                {
                    path: 'fuentes-de-ingreso',
                    children: [
                        { index: true, element: <PageFuenteIngreso /> },
                        { path: 'new', element: <PageFuenteIngreso /> },
                        { path: ':id', element: <PageFuenteIngreso /> }
                    ]
                },
                {
                    path: 'niveles-de-aprobacion',
                    children: [
                        { index: true, element: <PageNivelAprobacion /> },
                        { path: 'new', element: <PageNivelAprobacion /> },
                        { path: ':id', element: <PageNivelAprobacion /> }
                    ]
                },
                {
                    path: 'categorias-evaluacion',
                    children: [
                        { index: true, element: <PageCategoriaEvaluacion /> },
                        { path: 'new', element: <PageCategoriaEvaluacion /> },
                        { path: ':id', element: <PageCategoriaEvaluacion /> }
                    ]
                },
                {
                    path: 'areas',
                    children: [
                        { index: true, element: <PageAreaEmployee /> },
                        { path: 'new', element: <PageAreaEmployee /> },
                        { path: ':id', element: <PageAreaEmployee /> }
                    ]
                },
                {
                    path: 'cargos',
                    children: [
                        { index: true, element: <PageCargoEmployee /> },
                        { path: 'new', element: <PageCargoEmployee /> },
                        { path: ':id', element: <PageCargoEmployee /> }
                    ]
                },
                {
                    path: 'centro-poblado',
                    children: [
                        { index: true, element: <PagePopulationCenter /> },
                        { path: 'new', element: <PagePopulationCenter /> },
                        { path: ':id', element: <PagePopulationCenter /> }
                    ]
                },
                {
                    path: 'productos',
                    children: [
                        { index: true, element: <PageProducto /> },
                        { path: 'new', element: <PageProducto /> },
                        { path: ':id', element: <PageProducto /> }
                    ]
                },
                { path: 'permission-components',  element: <PagePermissionComponents /> },
                { path: 'permission-areas-cargos-components', element: <PagePermissionAreaCargoComponents /> },
                {
                    path: 'employees',
                    children: [
                        { index: true, element: <PageEmployee /> },
                        { path: 'new', element: <PageEmployee /> },
                        { path: ':id', element: <PageEmployee /> },
                      ],
                },
                { path: 'users',  element: <PageUser /> },
                { path: 'prospection', element: <PageProspection /> },
                { path: 'register-contact', element: <PageRegContact /> },
                {
                    path: 'evaluation',
                    children: [
                        { index: true, element: <PageEvaluation /> },
                        { path: 'step-02', element: <PageEvaluation /> },
                    ]
                },
                {
                    path: 'approval',
                    children: [
                        { index: true, element: <PageApproval /> },
                    ]
                },
                {
                    path: 'approval-rate',
                    children: [
                        { index: true, element: <PageApprovalRate /> },
                    ]
                },
                {
                    path: 'disburse',
                    children: [
                        { index: true, element: <PageDisburse /> },
                    ]
                },
                { path: 'cargos-por-area', element: <PageCargosAreaEmployee /> },
                { path: 'transaction-credit',  element: <PageTransactionCredit /> },
                { 
                    path: 'document-series',
                    children: [
                        { index: true, element: <PageSerieDocument /> },
                        { path: 'new', element: <PageSerieDocument /> },
                        { path: ':id', element: <PageSerieDocument /> }
                    ]
                },
                { 
                    path: 'cuentas-contables',
                    children: [
                        { index: true, element: <PageCuentaContable /> },
                        { path: 'new', element: <PageCuentaContable /> },
                        { path: ':id', element: <PageCuentaContable /> }
                    ]
                },
                { 
                    path: 'boxs',
                    children: [
                        { index: true, element: <PageCaja /> },
                        { path: 'new', element: <PageCaja /> },
                        { path: ':id', element: <PageCaja /> }
                    ]
                },
                { 
                    path: 'metodos-pago',
                    children: [
                        { index: true, element: <PageMetodoPago /> },
                        { path: 'new', element: <PageMetodoPago /> },
                        { path: ':id', element: <PageMetodoPago /> }
                    ]
                },
                { 
                    path: 'conceptos-pago',
                    children: [
                        { index: true, element: <PageConceptoPagoCaja /> },
                        { path: 'new', element: <PageConceptoPagoCaja /> },
                        { path: ':id', element: <PageConceptoPagoCaja /> }
                    ]
                },
                { 
                    path: 'movimientos-caja',
                    children: [
                        { index: true, element: <PageMovimientoCaja /> },
                        { path: 'new', element: <PageMovimientoCaja /> },
                        { path: ':id', element: <PageMovimientoCaja /> }
                    ]
                },
                { path: 'home',  element: <PageHome /> },
                // { path: 'usuarios', element: <Usuario /> },
                // { path: 'medicos',  element: <Medico /> },
                // { path: 'configuracion/:medicoId', element: <Configuracion /> },
                // { path: 'programacion', element: <Programacion /> },
                // { path: 'tipousuarios',  element: <TipoUsuarios /> },
                // { path: 'convenios',  element: <Convenios /> },
                // { path: 'inicio', element: <DashboardMedico /> },
                // { path: 'periodos', element: <Periodo /> },
                // { path: 'citas', element: <Cita /> },
                // { path: 'pacientes', element: <Paciente /> },
                // { path: 'notificaciones', element: <Notificaciones /> }
               
                // { path: '*', element: <Navigate to="/" replace /> }
            ],
        },
        // {
        //     path: 'expired-session',
        //     element: <ExpiredSession/>
        // },
        // {
        //     path:'/login',
        //     element: <Navigate to="/" replace />
        // },
        // {
        //     path: '*',
        //     element: <Error404 />
        // },
        {
            path: '/',
            element: <Login />
        }
    ], 
    // {
    //     future: {
    //         v7_startTransition: true,
    //         v7_relativeSplatPath: true,
    //     }
    // }
    );

    return routes;
    // return (
    //     <RouterProvider router={routes} />
    // );
}

export default App
